// extracted by mini-css-extract-plugin
module.exports = {"root":"_34KoG"};